import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Wrench, Car, Phone, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BottomNavbar = () => {
    const location = useLocation();
    const { isAuthenticated, isAdmin } = useAuth();

    const isActive = (path) => location.pathname === path;

    return (
        <div className="bottom-navbar">
            <div className="bottom-nav-container">
                <Link to="/" className={`nav-item ${isActive('/') ? 'active' : ''}`}>
                    <Home size={24} />
                    <span>Accueil</span>
                </Link>

                <Link to="/mecanique" className={`nav-item ${isActive('/mecanique') ? 'active' : ''}`}>
                    <Wrench size={24} />
                    <span>Mécanique</span>
                </Link>

                <div className="nav-item-center">
                    <a href="tel:+33645219585" className="urgent-btn">
                        <Phone size={28} />
                    </a>
                </div>

                <Link to="/vente-auto" className={`nav-item ${isActive('/vente-auto') ? 'active' : ''}`}>
                    <Car size={24} />
                    <span>Vente Auto</span>
                </Link>

                <Link 
                    to={isAuthenticated ? (isAdmin ? "/admin" : "/mon-compte") : "/inscription"} 
                    className={`nav-item ${isActive('/mon-compte') || isActive('/admin') ? 'active' : ''}`}
                >
                    <User size={24} />
                    <span>{isAdmin ? 'Admin' : 'Compte'}</span>
                </Link>
            </div>

            <style jsx>{`
                .bottom-navbar {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 1000;
                    display: none; /* Hidden by default, shown on mobile */
                }

                @media (max-width: 768px) {
                    .bottom-navbar {
                        display: block;
                    }
                }

                .bottom-nav-container {
                    background: rgba(255, 255, 255, 0.9);
                    backdrop-filter: blur(15px);
                    -webkit-backdrop-filter: blur(15px);
                    border-top: 1px solid rgba(0, 0, 0, 0.05);
                    height: 65px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    padding: 0 10px;
                    padding-bottom: env(safe-area-inset-bottom); /* Support for modern phone notches */
                    box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.05);
                }

                /* Dark mode support or theme awareness could be added here if needed */
                
                .nav-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-decoration: none;
                    color: #64748b;
                    transition: all 0.3s ease;
                    flex: 1;
                    padding-top: 2px;
                }

                .nav-item span {
                    font-size: 0.6rem;
                    font-weight: 600;
                    margin-top: 4px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .nav-item.active {
                    color: #1A365D;
                }

                .nav-item.active svg {
                    stroke-width: 2.5px;
                }

                .nav-item-center {
                    position: relative;
                    width: 70px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                }

                .urgent-btn {
                    position: absolute;
                    top: -20px;
                    width: 58px;
                    height: 58px;
                    background: linear-gradient(135deg, #0EA5E9 0%, #2563EB 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    box-shadow: 0 8px 20px rgba(14, 165, 233, 0.35);
                    border: 4px solid #fff;
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }

                .urgent-btn:active {
                    transform: scale(0.9);
                }

                .urgent-btn:hover {
                    box-shadow: 0 12px 25px rgba(14, 165, 233, 0.5);
                    transform: translateY(-2px);
                }
            `}</style>

            <style jsx global>{`
                @media (max-width: 768px) {
                    body {
                        padding-bottom: calc(65px + env(safe-area-inset-bottom)) !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default BottomNavbar;
